import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CallEndIcon(props: IconProps) {
    return <Icon {...props} iconKey={"call_end"}/>
}
